export class Bombs {
    constructor(physics) {
      if (!physics) throw new Error('parameter physics is missing');
		  this.bombs = physics.add.group();
      this.count = 0;
    }

    grp() {
      return this.bombs;
    }

    createOnRightScreen() {
      this.createAt(Phaser.Math.Between(400, 800))
    }
    createOnLeftScreen() {
      this.createAt(Phaser.Math.Between(0, 400))
    }
    createAt(x) {
      if (!x|| x<0||x>800) throw new Error("invalid argument: x")
      
      this.count++;

      var bomb = this.bombs.create(x, 16, 'bomb');
      bomb.name = 'b-'+this.count;
      bomb.setBounce(.99);
      bomb.setCollideWorldBounds(true);
      bomb.setVelocity(Phaser.Math.Between(-200, 200), 20);
    }
}